<div
  class="flex flex-wrap items-center gap-2xl transition-opacity"
  [class.opacity-50]="loading() && rows().length">
  <div class="shrink-0">
    @if (loading() && !rows().length) {
      <div class="size-[10rem]">
        <lib-loader size="lg" />
      </div>
    } @else {
      <lib-charts-wrapper
        type="doughnut"
        [id]="chartId()"
        [labels]="labels()"
        [datasets]="datasets()"
        [title]="centerTitle()"
        [value]="total()"
        [doughnutChartCutout]="cutout"
        [height]="size"
        [width]="size" />
    }
  </div>

  <ul class="flex flex-col flex-1 min-w-[14rem]">
    @for (row of rowViews(); track row.key) {
      @let isActive = activeKey() === row.key;
      <li>
        <button
          type="button"
          data-insight-legend-row
          class="grid w-full grid-cols-[minmax(0,1fr)_auto_3.5rem] items-center gap-md rounded-md px-sm py-x-sm text-start text-sm transition-colors"
          [class]="rowClass()"
          [class.bg-neutral-100]="isActive"
          [class.opacity-50]="activeKey() && !isActive"
          [attr.aria-pressed]="selectable() ? isActive : null"
          [disabled]="!selectable()"
          (click)="select(row)">
          <span class="flex min-w-0 items-center gap-sm">
            <span
              class="size-2.5 shrink-0 rounded-sm"
              [style.background-color]="row.color"></span>
            <span class="truncate text-neutral-900">{{ row.label }}</span>
          </span>
          <span class="font-semibold text-neutral-900 tabular-nums">
            {{ row.value }}
          </span>
          <span
            class="justify-self-end rounded-full bg-neutral-100 px-sm py-px text-xs text-neutral-700 tabular-nums">
            {{ row.percentage }}
          </span>
        </button>
      </li>
    }
  </ul>
</div>
